/**
 * Kopfzeile der Ansichtsseiten (REQ-21 §3).
 *
 * Der blaue Balken des Altclients ist der freistehenden Titelzeile des Entwurfs gewichen:
 * Ansichtsname als Überschrift, darunter die Zahl der Einträge, rechts die Schaltflächen.
 * Die Klassennamen `view-header`, `view-header-name` und `buttons` bleiben (REQ-19 §1) und
 * tragen weiterhin die Regeln aus `components/_view-header.scss`; die `iwm-*`-Klassen
 * ergänzen, was der Entwurf zusätzlich verlangt.
 *
 * „Zuletzt aktualisiert vor 4 Minuten" aus dem Entwurf entfällt — dafür gibt es keinen
 * Zeitstempel.
 */

import type { ReactNode } from 'react';

import { useGridRowCount } from '@/components/grid/gridRowCountContext';
import type { ChinaAppSysView } from '@/types/entities';
import { formatNumber } from '@/utils/number';

import { ViewToolbar } from './ViewToolbar';

export interface ViewPageHeadProps {
  view: ChinaAppSysView | null;
  toolbar: ReactNode;
}

export function ViewPageHead(props: ViewPageHeadProps) {
  const count = useGridRowCount();

  return (
    <div className="view-header iwm-view-head">
      <div className="iwm-view-title">
        <h1 className="view-header-name">{props.view?.ViewName}</h1>
        {count === null ? null : (
          <div className="iwm-view-sub">
            <span className="iwm-num">{formatNumber(count, 'N0')}</span> Einträge
          </div>
        )}
      </div>
      <ViewToolbar>{props.toolbar}</ViewToolbar>
    </div>
  );
}

export default ViewPageHead;
